const FIND_APPS_DESCRIPTION_QUERY_KEY = "find-apps:description";

type FindAppsQueryKeys = {
    description: () => readonly string[];
};

export const findAppsQueryKeys: FindAppsQueryKeys = {
    description: (): readonly string[] => [FIND_APPS_DESCRIPTION_QUERY_KEY],
};
